import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";

// Schema
export const signatureSchema = itemSchema.extend({
  content: z.string().default(""),
  image: z.string().optional(),
  date: z.string().optional(),
});

// Type
export type Signature = z.infer<typeof signatureSchema>;

// Defaults
export const defaultSignature: Signature = {
  ...defaultItem,
  content: "",
  image: undefined,
  date: undefined,
};
